import { Paso } from './Paso';

export class PasoProcesador extends Paso {
  constructor() {
    super(
      true,
      'Procesador',
      `Tu procesador es la pieza central del rendimiento de los programas.
      Para saber si un procesador es potente lo que tenés que medir es la frecuencia, el ancho de bus, la memoria caché y los núcleos e hilos de procesamiento.`,
      1,
      'cpu.png',
      'cpu.png',
      false,
      [],
      '',
    );
  }
}
